export const SET_INNER_MODAL_OPENED = 'SET_INNER_MODAL_OPENED';
export const SET_COLLAPSABLE_EXPANDED_ITEMS = 'SET_COLLAPSABLE_EXPANDED_ITEMS';
export const SET_LOCATION_PARAMS = 'SET_LOCATION_PARAMS';
export const TOGGLE_COLLAPSABLE_EXPANDED_ITEM = 'TOGGLE_COLLAPSABLE_EXPANDED_ITEM';
export const DATE_PICKER_CANCEL = 'DATE_PICKER_CANCEL';
export const SET_LOADING = 'SET_LOADING';
